<script setup lang="ts">
import Paginator from '@kidzonet/isp-admin-paginator'

interface CustomPolicyPaginatorInterface {
    page: number
    pagesCount: number
}

defineProps<CustomPolicyPaginatorInterface>()
const emit = defineEmits<{
    (e: 'paginate', value: number): void
}>()

const paginate = (page: number) => {
    emit('paginate', page)
}

// eslint-disable-next-line ts/ban-ts-comment
// @ts-ignore
const useIspAdminPaginator = window.isp_admin_V3 || false
</script>

<template>
    <Paginator
        v-if="useIspAdminPaginator"
        :page="page"
        :pages-count="pagesCount"
        @paginate="paginate"
    />
    <v-pagination
        v-else
        :model-value="page"
        :length="pagesCount"
        @update:model-value="paginate"
        :total-visible="4"
        active-color="primary"
        density="compact"
        variant="elevated"
        class="kidzonet-paginator"
    />
</template>

<style>
    .kidzonet-paginator {
        .v-btn--icon.v-btn--density-compact {
            inline-size: 100%;
            min-inline-size: calc(var(--v-btn-height) + -8px);
            padding: 0 0.5em;
        }
    }
</style>
